// Sets Upsell - Product Recommendations Integration
// Uses Shopify Product Recommendations API to show related products for sets

if (!customElements.get("sets-upsell-cart")) {
    customElements.define("sets-upsell-cart", class extends HTMLElement {
        constructor() {
            super();
            this.hasQualifyingSets = false;
            this._pendingUpsellProduct = null;
        }

        connectedCallback() {
            document.addEventListener("cart:change", this.handleCartChange.bind(this));
            document.addEventListener("cart:refresh", this.handleCartRefresh.bind(this));

            // Upsell tracking
            this.addEventListener('click', this._onUpsellClick.bind(this));
            this.addEventListener('submit', this._onUpsellSubmit.bind(this));
            document.addEventListener('cart:change', this._onUpsellCartChange.bind(this));

            this.initializeFromCurrentCart();
        }

        _trackEvent(name, params) {
            if (window.gtag) gtag('event', name, params);
        }

        // Tracks click on product image/button that opens the quick-buy popup (multi-variant)
        _onUpsellClick(e) {
            const btn = e.target.closest('[aria-controls]');
            if (!btn) return;
            const productName = this._getProductName(btn);
            this._pendingUpsellProduct = productName;
            this._trackEvent('upsell_click', { product: productName, location: 'cart_drawer' });
        }

        // Tracks direct add-to-cart for single-variant and variant-picker cards
        _onUpsellSubmit(e) {
            if (!e.target.classList.contains('sets-upsell-form')) return;
            const productName = this._getProductName(e.target);
            this._trackEvent('upsell_add_to_cart', { product: productName, location: 'cart_drawer' });
        }

        // Tracks add-to-cart that happens inside the quick-buy modal popup
        _onUpsellCartChange() {
            if (!this._pendingUpsellProduct) return;
            this._trackEvent('upsell_add_to_cart', { product: this._pendingUpsellProduct, location: 'cart_drawer_modal' });
            this._pendingUpsellProduct = null;
        }

        _getProductName(el) {
            const card = el.closest('.horizontal-product-card');
            return card?.querySelector('.product-title')?.textContent?.trim() || '';
        }

        async initializeFromCurrentCart() {
            try {
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();
                await this.updateSetsUpsellVisibility(cart);
            } catch (error) {
                console.error('Error fetching cart for sets upsell:', error);
            }
        }

        handleCartChange(event) {
            if (event.detail && event.detail.cart) {
                this.updateSetsUpsellVisibility(event.detail.cart);
            }
        }

        async handleCartRefresh() {
            await this.initializeFromCurrentCart();
        }

        async handleFormSubmit(event) {

            if (!event.target.classList.contains('sets-upsell-form')) {
                return;
            }

            event.preventDefault();
            const form = event.target;
            const formData = new FormData(form);
            const button = form.querySelector('button[type="submit"]');

            try {
                this.setButtonState(button, 'Adding...', true);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(Object.fromEntries(formData))
                });

                if (response.ok) {

                    document.dispatchEvent(new CustomEvent('cart:refresh'));


                    this.setButtonState(button, 'Added!', true);
                    setTimeout(() => {
                        this.setButtonState(button, 'Add to Cart', false);
                    }, 2000);
                } else {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error adding sets upsell product to cart:', error);
                this.setButtonState(button, 'Add to Cart', false);
            }
        }

        setButtonState(button, text, disabled) {
            button.textContent = text;
            button.disabled = disabled;
        }

        async updateSetsUpsellVisibility(cart) {
            if (!this) return;

            const setsProductId = this.getAttribute('data-sets-product-id');
            const wasHidden = this.style.display === 'none' || this.style.display === '';

            if (setsProductId && setsProductId !== '') {
                await this.loadRecommendedProducts(setsProductId);
                this.style.display = 'block';
                this.hasQualifyingSets = true;
                if (wasHidden) {
                    this._trackEvent('upsell_view', { location: 'cart_drawer' });
                }
            } else {
                this.style.display = 'none';
                this.hasQualifyingSets = false;
            }
        }

        async loadRecommendedProducts(productId) {
            try {
                const endpoint = `/recommendations/products?product_id=${productId}&intent=complementary&limit=10&section_id=api-products-sets`;
                const response = await fetch(endpoint);
 
                if (response.ok) {
                    const html = await response.text();
                    // Look for the products container within this component
                    const productsContainer = this.querySelector('#sets-upsell-products');

                    if (productsContainer && html.trim().length > 0) {
                        productsContainer.innerHTML = html;
                    }
                }
            } catch (error) {
                console.error('Error loading recommended products:', error);
            }
        }
    });
}